import React from 'react'

import Icon from '@f/elements/Icon'
import paidVendorImagesData from '@f/applications/QuizApp/partials/paidVendorImagesData'
import { staticAsset } from '@js/common/utils'

const QuizBottom = () => (
  <div className='QuizApp-checkout-bottom'>
    <div className='[ f-p-v-010 f-p-v-020:m ]' style={{ width: '100%' }}>
      <div className='[ f-wrap ]'>
        <div className='[ f-d-flr f-fl-al-ce f-fl-jc-ce f-p-v-020 ]'>
          <div>
            {[1, 2, 3, 4, 5].map(s => {
              if (s === 5) {
                return (
                  <span key={`star_rating_m_${s}`} className='[ f-pos-rel ]'>
                    <Icon
                      icon='star-filled-16px-fill'
                      className='[ f-icon-030 f-c-fi-neu100 ]'
                    />
                    <span
                      className='[ f-pos-ab f-overflow ]'
                      style={{ left: '12px' }}>
                      <Icon
                        icon='star-filled-16px-fill'
                        className='[ f-icon-030 f-c-fi-neu025 ]'
                        style={{
                          marginLeft: '-12px'
                        }}
                      />
                    </span>
                  </span>
                )
              }

              return (
                <Icon
                  key={`star_rating_m_${s}`}
                  icon='star-filled-16px-fill'
                  className='[ f-icon-030 f-c-fi-neu100 ]'
                  style={{
                    marginRight: '4px'
                  }}
                />
              )
            })}
          </div>
          <span className='[ f-d-bl f-t-body f-c-fo-neu100 f-hidden:s f-m-l-010 ]'>
            <span className='[ f-t-bold ]'>4.4</span> /{' '}
            <span className='[ f-t-bold ]'>5</span>
          </span>
        </div>
        {window.__DOMAIN__ === 'fertighaus' && (
          <span className='[ f-d-bl f-t-tbody f-c-fo-neu100 f-t-centre f-m-b-020 ]'>
            Deutschlands Hausbauportal Nr. 1 seit 1996
          </span>
        )}
      </div>
    </div>
    <div className='[ f-p-v-010 f-p-v-020:m f-c-ba-whi ]'>
      <div className='[ f-wrap ]'>
        <div className='[ f-d-flr f-m-t-010 ] QuizApp-vendors'>
          {paidVendorImagesData.map(({ src, width, height }) => (
            <img
              key={src}
              src={staticAsset(src)}
              width={width}
              height={height}
              className='[ f-p-h-020 ] QuizApp-vendor'
              loading='lazy'
            />
          ))}
        </div>
      </div>
    </div>
  </div>
)

export default QuizBottom
